import { useNavStateSync } from '@/common/hooks/navState/useNavStateSync';
import { StringUtils } from '@/common/utils/StringUtils';
import { Tab, Tabs } from '@mui/material';
import { useEffect, useMemo } from 'react';
import { useEntityMgr } from '../entityView/EntityMgrContext';
import { EntityFormMode } from '../enumerations/EntityFormMode';
import { TabProvider } from './TabContext';

export const EntityTabs = ({ id, tabSpecs }) => {
  const { entityFormMode } = useEntityMgr();

  const formAware = tabSpecs[0]?.label === 'Info';
  const navStateKey = id ? id + StringUtils.toUpperCamel('selectedTabIndex') : 'selectedTabIndex';

  const [selectedTabIndex, setSelectedTabIndex] = useNavStateSync(navStateKey, 0);

  useEffect(() => {
    if (formAware && entityFormMode === EntityFormMode.EDIT) {
      setSelectedTabIndex(0);
    }
  }, [entityFormMode]);

  const infoOnly = useMemo(() => {
    if (!formAware) return false;
    return entityFormMode === EntityFormMode.ADD || entityFormMode === EntityFormMode.EDIT;
  }, [formAware, entityFormMode]);

  return (
    <>
      <Tabs
        value={selectedTabIndex}
        onChange={(event, newTabIndex) => setSelectedTabIndex(newTabIndex)}
        sx={{ borderBottom: 1, borderColor: 'divider' }}
        variant="scrollable"
        scrollButtons="auto"
      >
        {tabSpecs.map((tabSpec, index) => (
          <Tab
            id={tabSpec.id + 'Tab'}
            label={tabSpec.label}
            key={tabSpec.id}
            disabled={(infoOnly && index > 0) || tabSpec.disabled}
          />
        ))}
      </Tabs>
      {tabSpecs.map((tabSpec, index) => (
        <TabPanel value={selectedTabIndex} index={index} id={tabSpec.id + 'Panel'} key={tabSpec.id + 'Panel'}>
          <TabProvider tabId={tabSpec.id} tabLabel={tabSpec.label}>
            {tabSpec.content}
          </TabProvider>
        </TabPanel>
      ))}
    </>
  );
};

const TabPanel = ({ children, value, index, ...other }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      style={{
        display: value === index ? 'flex' : 'none',
        flexDirection: 'column',
        flexGrow: 1,
        height: '100%',
        minHeight: 0,
      }}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
};
